module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-uploader"
  }, [_c('div', {
    staticClass: "el-upload el-upload--text"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.getAsset(_vm.imagePath, undefined, _vm.logo)
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['el-button', ' el-button--dark'],
    attrs: {
      "crop-ratio": "1:1",
      "crop": true,
      "max-file-size": 409600,
      "text": _vm.$t('UPLOADIMAGE'),
      "cropBtn": {
        'ok': _vm.$t('SAVEIMAGE'),
        'cancel': _vm.$t('CANCEL')
      },
      "url": _vm.URL + 'media/upload',
      "data": {
        folder: _vm.folder
      },
      "headers": {
        'X-API-KEY': _vm.API_KEY
      },
      "extensions": "png,gif,jpeg,jpg",
      "inputOfFile": "file"
    },
    on: {
      "errorhandle": _vm.imageError,
      "imageuploaded": _vm.imageUploaded
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "WIUpload",
      "size": "tiny",
      "visible": _vm.messageBox
    },
    on: {
      "close": _vm.resetUpload,
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, [_c('span', {
    staticClass: "el-alert__title is-bold"
  }, [_vm._v(_vm._s(_vm.message)), _c('br')])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.messageBox = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90212a42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Upload.vue
// module id = 620
// module chunks = 1